module.exports = __webpack_public_path__ + "img/27.bfeed0a5.jpg";